import { Component } from '@angular/core';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'toastr-ng2';
const swal = require('sweetalert');
@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent  {

      siteVal:any;
     news:Array<any>;
         newsData: FirebaseListObservable<any>;

    constructor(public af:AngularFireDatabase, public router:Router,public toastr: ToastrService) {
     this.newsData= af.list('/news');
         this.newsData.subscribe((res)=>{
         this.news = res;
     }); 
    }


  getnews(ev: any) {
        let val = ev;
        this.newsData = this.af.list('/news', {
            query: {
                orderByChild: 'title',
                startAt: val.charAt(0).toUpperCase() + val.slice(1),
                endAt: val.charAt(0).toUpperCase() + val.slice(1) + '\uf8ff'
            }
        });
        this.newsData
            .subscribe((data) => {
                this.news = data;
            });


    }


   newsShow(key){
     this.router.navigate(['/news/viewNews', key]);
  }
  
   newsEdit(key){
    this.router.navigate(['/news/editNews', key]);
  }

   menuItemEdit(key){
    this.router.navigate(['/menu/editItems', key]);
  }
 
   newsDelete(key:any){
    swal({
            title: 'Are you sure?',
            text: 'Your will not be able to recover this data!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            closeOnConfirm: false,
            closeOnCancel: false
        }, (isConfirm) => {
            if (isConfirm) {
               this.newsData.remove(key).then((res)=>{
                   swal('Deleted!','News Deleted Successfully!', 'success');
                 })
              } else {
                swal('Cancelled', 'Your data is safe :)', 'error');
            }
        });
  }
}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/ShunFa/ShunFa-Restaurant Backend/Restaurant_Firebasebackend/webapp/src/app/routes/restaurant/news/news.component.ts